import styled from '@emotion/styled';

export const StyledIframe = styled.iframe`
  border: none;
`;
